import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import WithRouter from 'custom/withRouter';
import { getAggregateInventoryLevel, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import { clearProductList } from 'actions/EntityActions';
import { reportAggregateInventoryLevel } from 'utils/breadcrumbInfo';
// Basic Comoponents
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import Pagination from 'screens/components/basic/Pagination';
import CardSimple from 'screens/components/basic/CardSimple';

import Body from './Body';
import Header from './Header';


class AggregateInventoryLevel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 10,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillUnmount() {
        this.props.clearProductList();
    }

    getReport = () => {
        let productId = this.props.selectedProductId || 0;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getAggregateInventoryLevel({ productId, pageNumber, pageSize });
    }

    downloadReport = () => {
        let productId = 0;
        let pageNumber = 1;
        let pageSize = 999;
        this.props.getCsvReport(`reports/excel/aggregateInventoryLevel?productId=${productId}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "aggregateInventoryLevel");
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    getProductOptions = () => {
        return (this.props.products || []).map(item => {
            return {
                text: item.name,
                value: item.id,
                categoryId: item.id
            };
        });
    }

    render() {
        return (
            <Grid headerContent={reportAggregateInventoryLevel}>
                <PageHeader
                    title={LOOKUP.report.aggregateInventoryLevel.text} 
                    icon={<KnowledgeBase />}
                    description={LOOKUP.report.aggregateInventoryLevel.description}
                />
                <Header
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    products={this.getProductOptions()}
                />
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body aggregateInventoryLevel={this.props.aggregateInventoryLevel} />
                        {
                            this.props.selectedProductId === 0 &&
                            <Pagination
                                length={999}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        }
                    </CardSimple>
                }
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    return {
        aggregateInventoryLevel: state.reports.aggregateInventoryLevel || [],
        products: state.entity.productList,
        selectedProductId: state.form.AggregateInventoryLevelProductId || 0
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getAggregateInventoryLevel: (model) => dispatch(getAggregateInventoryLevel(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearProductList: () => dispatch(clearProductList()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(AggregateInventoryLevel));